<div>
  <app-admin-data-grid />
</div>
